<template>
    <div class="tpl-portlet-content">
        <div class="qa_item_div" v-for="collect in collect_results" :key="collect['id']">
            <div class="qa_item_question_div">
                <router-link tag="a"
                             :to="{ name: 'user', params: { id: collect.collect_info.category_info.author.id } }">
                    <img :src="collect.collect_info.category_info.author.avatar_url"
                         class="item_question_avatar"/>
                </router-link>
                <div class="item_question">
                    <router-link :to="{ name: 'post', params: { id: collect.collect_info.category_info.number } }"
                                 tag="a"
                                 class="item_question_title">
                        {{collect.collect_info.category_info.title}}
                    </router-link>
                    <div class="item_question_content" v-if="collect.collect_info.category_info.content_description.length<=100">
                        {{collect.collect_info.category_info.content_description}}
                    </div>
                    <div class="item_question_content" v-else>
                        {{collect.collect_info.category_info.content_description.substring(0,100)}}......
                    </div>
                    <div class="item_question_base_info">
                        <!--  -->
                        <span class="margin-right-10"> {{collect.collect_info.category_info.author.name}}</span>
                        <!--<span class="level margin-right-10">L{{collect.collect_info.category_info.author.level}}</span>-->
                        <span class="margin-right-10">{{collect.collect_info.category_info.created_at}}</span>
                        <span class="margin-right-10">发布于</span>
                        <span style="color: #66CCFF" class="margin-right-10">{{collect.collect_info.category_info.column.display_name}}</span>
                        <span style="color: #00965e" class="margin-right-10" v-for="tag in collect.collect_info.category_info.tags" :key="tag['id']">{{tag.name}}</span>
                    </div>
                </div>
            </div>
            <div class="item_view_answer_div">
                <div class="view_answer_div answer_number_div" style="margin-top: 10px;">
                    <span class="view_span view_answer_span">{{collect.collect_info.category_info.comments_count}}</span>
                    <span class="view_span view_answer_span">回复</span>
                </div>
                <div class="view_answer_div view_number_div" style="margin-top: 10px;">
                    <span class="answer_span view_answer_span">{{collect.collect_info.category_info.views}}</span>
                    <span class="answer_span view_answer_span">查看</span>
                </div>

                <div class="view_answer_div view_number_div">
                    <a v-if="collect.login_user_collect_state" class="answer_span view_answer_span"
                       @click="change_collect_state(collect,'do_cancel')"
                       style="text-decoration: underline;color: #66CCFF;padding-top: 18px;">取消收藏</a>
                    <a v-else class="answer_span view_answer_span"
                       @click="change_collect_state(collect,'do_collect')"
                       style="text-decoration: underline;color: #66CCFF;padding-top: 18px;">收藏</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import UserApi from '@/api/user/user.js'
    import CollectApi from '@/api/collect/collect.js'
    import {mapState, mapGetters, mapActions} from 'vuex'

    export default {
        data: function () {
            return {
                collect_results: [],
            }
        },
        components: {},
        computed: {
            ...mapState({
                login_user_id: state => state.loginState.user_info.id,
            }),
            ...mapGetters({}),
        },
        methods: {
            ...mapActions({}),
            async change_collect_state(collect, action) {
                let args = {
                    'collect_state_tag': true,
                    'id': collect.collect_info.category_info.id,
                    'type': 'ujoyer.post'
                }
                if (action === 'do_collect') {
                    args.collect_state_tag = false
                }
                CollectApi.change_collect_state(args).then((res) => {
                    let data = JSON.parse(res.data.result);
                    if (data.code == 'success') {
                        let index
                        for (let i = 0; i < this.collect_results.length; i++) {
                            if (this.collect_results[i].id === collect.id) {
                                index = i
                                break
                            }
                        }
                        this.collect_results[index].login_user_collect_state = !args.collect_state_tag
                    }
                })
            },
        },
        mounted() {
            UserApi.get_user_collects({'id': this.login_user_id, 'type': 'ujoyer.post'}).then((res) => {
                this.collect_results = res.data;
            })
        }
    }
</script>

<style scoped>
    .tpl-portlet-content {
        height: 455px;
        overflow: auto
        /*background: red;*/
    }

    .item_question_content {
        line-height: 24px;
        margin-top: 11px;
    }

    .qa_item_div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
        border-bottom: 1px solid #eee;
    }

    .qa_item_question_div {
        display: flex;
        width: 83%;
    }

    .item_question {
        display: flex;
        flex-direction: column;
        padding: 0 15px;
        max-width: 83%;
        /*max-width: 600px;*/
    }

    .item_question_avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-left: 15px;
        margin-top: 20px;
    }

    .item_question_title {
        display: inline-block;
        white-space: nowrap;
        font-size: 18px;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #0181da;
        max-width: 100%;
        font-weight: bold
    }

    .item_question_base_info {
        margin-top: 8px;
        font-size: 13px;
        color: #9b9da2;
    }

    .item_view_answer_div {
        display: flex;
        width: 16%;
        /*margin: 0 30px;*/
        padding: 0 15px;
        justify-content: space-around;
    }

    .view_answer_div {
        display: flex;
        flex-direction: column;
        /*margin-right: 5px;*/
    }

    .view_answer_span {
        font-size: 14px;
        text-align: center;
    }

    .view_span {
        color: #6CF;
    }

    .level {
        color: #ffc500;
    }

    .margin-right-10 {
        margin-right: 10px;
    }

</style>